import { apiService } from "./api.service";
import { Language } from "types/index";
import { Lookup } from "types/lookup";
import { PaginatedResponse } from "types/index";
import api_no_token_Service from "./api_no_token.service";

export interface LookupDto {
  Id?: number;
  id?: number;
  LookupId?: number;
  lookupId?: number;
  Code?: string;
  code?: string;
  Name?: string;
  name?: string;
  NameEN?: string;
  nameEN?: string;
}

class LookupService {
  async create(payload: Partial<Lookup>): Promise<Lookup> {
    const response = await apiService.post<Lookup>(`/lookup`, payload);
    if ((response as any)?.data && (response as any)?.success !== false) {
      return (response as any).data as Lookup;
    }
    return response as any as Lookup;
  }

  async update(id: string, payload: Partial<Lookup>): Promise<Lookup> {
    const response = await apiService.put<Lookup>(`/lookup/${id}`, payload);
    if ((response as any)?.data && (response as any)?.success !== false) {
      return (response as any).data as Lookup;
    }
    return response as any as Lookup;
  }

  async getByParentCode(
    parentCode: string,
    languageId: Language = Language.ENGLISH
  ): Promise<LookupDto[]> {
    const res = await api_no_token_Service.get<LookupDto[]>(
      `/lookup/GetByParentCode/${encodeURIComponent(
        parentCode
      )}?languageId=${languageId}`
    );
    if ((res as any)?.data && (res as any)?.success !== false) {
      return (res as any).data as LookupDto[];
    }
    return res as any as LookupDto[];
  }

  async getPageList(
    page: number = 1,
    limit: number = 100,
    languageId: number = 1
  ): Promise<PaginatedResponse<Lookup>> {
    const response = await apiService.get<PaginatedResponse<Lookup>>(
      `/lookup/GetPageList?page=${page}&pageSize=${limit}&languageId=${languageId}`
    );

    if (
      (response as any)?.data &&
      (response as any)?.success !== false &&
      (response as any).data?.data &&
      (response as any).data?.pagination
    ) {
      return (response as any).data as PaginatedResponse<Lookup>;
    }
    const maybeItems = (response as any)?.items;
    const maybeTotal = (response as any)?.totalCount;
    if (Array.isArray(maybeItems) && typeof maybeTotal === "number") {
      const totalPages = Math.max(1, Math.ceil(maybeTotal / limit));
      return {
        data: maybeItems as Lookup[],
        pagination: { page, limit, total: maybeTotal, totalPages },
      };
    }

    const data = (response as any)?.data || response;
    if (Array.isArray(data)) {
      return {
        data: data as Lookup[],
        pagination: { page, limit, total: data.length, totalPages: 1 },
      };
    }

    throw new Error((response as any)?.message || "Failed to load lookups");
  }

  async getById(id: string): Promise<Lookup> {
    const response = await apiService.get<any>(`/lookup/${id}`);
    const payload: any = (response as any)?.data ?? response;

    const lookupData =
      payload?.data && typeof payload.data === "object"
        ? payload.data
        : typeof payload === "object"
        ? payload
        : null;

    if (lookupData) {
      return { ...lookupData } as Lookup;
    }

    return response as unknown as Lookup;
  }

  async getAll(): Promise<LookupDto[]> {
    const res = await apiService.get<LookupDto[]>(`/lookup`);
    if ((res as any)?.data && (res as any)?.success !== false) {
      return (res as any).data as LookupDto[];
    }
    return res as any as LookupDto[];
  }

  async remove(id: string): Promise<void> {
    const response = await apiService.delete(`/lookup/${id}`);
    if ((response as any)?.success === false) {
      throw new Error((response as any)?.message || "Delete failed");
    }
  }
}

export const lookupService = new LookupService();
export default lookupService;
